import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  activeFilters: ['all'],
  showNameplates: false,
  showGeofences: true,
  filterOptions: [
    { value: 'all', label: 'Total Fleet' },
    { value: 'mobile', label: 'Mobile' },
    { value: 'aurus', label: 'Aurus' },
    { value: 'triton', label: 'Triton' },
    { value: 'lg_band', label: 'LG Bands' },
    { value: 'vehicle', label: 'Vehicle' },
    { value: 'ebike', label: 'Ebike' },
    { value: 'boat', label: 'Boat' },
    { value: 'jeep', label: 'Cars and Jeep' },
    { value: 'bike', label: 'Bike' },
    { value: 'truck', label: 'Truck' },
    { value: 'atv', label: 'ATV' },
    { value: 'seahorse', label: 'Sea Horse' },
    { value: 'swimzone', label: 'Swimzones' },
    { value: 'towers', label: 'Towers' },
  ],
};

const filtersSlice = createSlice({
  name: 'filters',
  initialState,
  reducers: {
    setActiveFilters: (state, action) => {
      const filterToAdd = action.payload;
      console.log('🔍 setActiveFilters called with:', {
        filterToAdd: filterToAdd,
        currentActiveFilters: state.activeFilters,
        payloadType: typeof filterToAdd,
        isArray: Array.isArray(filterToAdd)
      });
      
      if (filterToAdd === 'all') {
        console.log('🔍 Setting activeFilters to ["all"]');
        state.activeFilters = ['all'];
        return;
      }
      
      // Handle array of filters (multi-select)
      if (Array.isArray(filterToAdd)) {
        console.log('🔍 Setting activeFilters to array:', filterToAdd);
        state.activeFilters = filterToAdd;
        return;
      }
      
      // For single filter, replace the entire array with the new filter
      console.log('🔍 Setting activeFilters to single filter:', filterToAdd);
      state.activeFilters = [filterToAdd];
    },
    removeFilter: (state, action) => {
      const filterToRemove = action.payload;
      const newFilters = state.activeFilters.filter(f => f !== filterToRemove);
      
      if (newFilters.length === 0) {
        state.activeFilters = ['all'];
      } else {
        state.activeFilters = newFilters;
      }
    },
    clearAllFilters: (state) => {
      state.activeFilters = ['all'];
    },
    toggleNameplates: (state) => {
      state.showNameplates = !state.showNameplates;
    },
    setShowNameplates: (state, action) => {
      state.showNameplates = action.payload;
    },
    toggleGeofences: (state) => {
      state.showGeofences = !state.showGeofences;
    },
    setShowGeofences: (state, action) => {
      state.showGeofences = action.payload;
    },
    setFilterOptions: (state, action) => {
      state.filterOptions = action.payload;
    },
  },
});

export const {
  setActiveFilters,
  removeFilter,
  clearAllFilters,
  toggleNameplates,
  setShowNameplates,
  toggleGeofences,
  setShowGeofences,
  setFilterOptions,
} = filtersSlice.actions;

export default filtersSlice.reducer;
